import { render, staticRenderFns } from "./CaseViewerHeaderCount.vue?vue&type=template&id=2900a7f4&scoped=true&"
import script from "./CaseViewerHeaderCount.vue?vue&type=script&lang=js&"
export * from "./CaseViewerHeaderCount.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewerHeaderCount.vue?vue&type=style&index=0&id=2900a7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900a7f4",
  null
  
)

export default component.exports